import PropTypes from 'prop-types';

import Modal from 'honeydew/Modal';

export function OrderMinInfoModal({ open, orderMinimum, setOpen }) {
    return (
        <Modal open={open} onClose={() => setOpen(false)} headline="Your order minimum">
            <p className="text-body-sm mt-20 text-grey">
                You must have an order subtotal of at least ${orderMinimum} (not including wine) for your order to ship.
                As long as your cart hits this subtotal when your shopping window closes, your order will ship - no
                check out needed!
            </p>
        </Modal>
    );
}

OrderMinInfoModal.propTypes = {
    open: PropTypes.bool.isRequired,
    orderMinimum: PropTypes.number,
    setOpen: PropTypes.func.isRequired,
};

OrderMinInfoModal.defaultProps = {
    orderMinimum: 0,
};
